export const titleTextColor = '#054E9A'